/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';
import { Button as MaterialButton } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

function Button(props) {
  return (
    <MaterialButton
      onClick={props.onClick}
      style={props.style}
      key={props.key}
      color={props.color}
      className={props.className}
      variant={props.variant}
      disabled={props.disabled}
      primary={props.color}
      size={props.size}
    >

      {props.label}
      {props.children}
    </MaterialButton>
  );
}

Button.propTypes = {
  onClick: PropTypes.func,
  style: PropTypes.object,
  key: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  variant: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  children: PropTypes.any,
  size: PropTypes.string,
};

Button.defaultProps = {
  onClick: () => {},
  label: '',
  children: null,
  style: { fontSize: '0.66rem' },
  key: '',
  color: 'default',
  className: '',
  variant: 'outlined',
  disabled: false,
  size: 'small',
};

const styles = {
  label: {
    fontSize: 14,
  },
};

export default withStyles(styles)(Button);
